module.exports = __webpack_public_path__ + "static/img/candle.3709ff5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/depositActivity/candle.svg
// module id = gCng
// module chunks = 0